<template>
	<div class="cursor-pointer">
		<div class="row">
			<button class="btn btn-secondary mt-2 btn-circle btn-lg text-white">
				<i class="fa fa-plus pull-right mr-1 mt-12"></i>
			</button>
			<div class="p-3">
				<slot></slot>
			</div>
		</div>
	</div>
</template>

<script>
	import Vue from 'vue';

	export default {
		name: 'PlusButton',
	}
</script>

<style scoped src="@/assets/css/button.css" rel="stylesheet"></style>



// WEBPACK FOOTER //
// src/components/global/miscellaneous/PlusButton.vue